var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.5V2.5H6.5V5.5H9.5V6.5H6.5V9.5H5.5V6.5H2.5V5.5H5.5Z",
    fill: "#85858E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGrey);
export default __webpack_public_path__ + "static/media/plus-grey.5d0d985d553e8881712dc3e568771717.svg";
export { ForwardRef as ReactComponent };